import { formatPrice } from "helpers/common";
import { useTranslation } from "react-i18next";
import { BsPatchCheckFill } from "react-icons/bs";

const Policy = ({ policy }) => {
    const { t } = useTranslation();
    return (
        <div className="d-flex gap-2 align-items-center my-2 text-xs ">
            <BsPatchCheckFill
                className={policy.chargeable ? `text-danger` : `text-success`}
            />
            <span className="d-flex gap-2 items-center">
                {"de:"}
                <span className="fw-bold">{` ${policy.from?.slice(
                    0,
                    16
                )} `}</span>
                {"a:"}
                {policy?.to && (
                    <span className="fw-bold">{` ${policy.to.slice(
                        0,
                        16
                    )} `}</span>
                )}
                {policy.chargeable ? (
                    <div className="text-danger">
                        {policy?.fees_type === "PERCENT_PRICE"
                            ? `${policy?.percent_price}%`
                            : policy?.fees_type === "FIXED_PRICE"
                            ? formatPrice(policy?.price?.total || policy?.price)
                            : policy?.nights + "  " + t("nights")}
                    </div>
                ) : (
                    <div className="text-success">{t("free")}</div>
                )}
            </span>
        </div>
    );
};

export default Policy;
